<template>
    <div>
        <download-content-buttons v-if="showPrintContentButton || showDownloadContentButton"
                                  :pagePartId="pagePartId"
                                  :showPrintContentButton="showPrintContentButton"
                                  :showDownloadContentButton="showDownloadContentButton"/>

        <div v-lazy-container="{ selector: 'img[data-src]' }" v-html="content" class="content-only-block"></div>
    </div>

</template>

<script>
export default {
    name: "ContentOnlyBlock",

    props: ['pagePartId', 'componentContent', 'showPrintContentButton', 'showDownloadContentButton'],

    computed:{
      content(){
          return this.componentContent && this.componentContent.content;
      } ,
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/contents/ContentOnlyBlock"
</style>